import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts"; // Import echarts directly
import { useTheme, alpha } from "@mui/material/styles"; // Import useTheme and alpha from MUI
import NoDataText from "../NoDataText/NoDataText";

const StackedGradientLineChart = ({ data }) => {
	// Access the MUI theme
	const theme = useTheme();

	// Check if the data is empty
	if (!data || data.length === 0) {
		return <NoDataText />;
	}

	// Prepare the chart options
	const colors = [
		[theme.palette.primary.light, theme.palette.primary.main],
		[theme.palette.secondary.light, theme.palette.secondary.main],
		[theme.palette.error.light, theme.palette.error.main],
		// Add more color pairs as needed
	];

	const options = {
		tooltip: {
			trigger: "axis",
		},
		xAxis: {
			type: "category",
			data: data[0].map((item) => item.date), // Assuming all datasets have the same dates
		},
		yAxis: {
			type: "value",
		},
		legend: {
			orient: "horizontal",
			left: "center",
			bottom: "bottom",
		},
		series: data.map((dataset, index) => ({
			name: dataset[0].name,
			data: dataset.map((item) => item.value),
			type: "line",
			stack: "total",
			smooth: true,
			emphasis: {
				focus: "series",
			},
			lineStyle: {
				width: 3,
				type: "solid",
				color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
					{ offset: 0, color: colors[index][0] },
					{ offset: 1, color: colors[index][1] },
				]),
			},
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    { offset: 0, color: alpha(colors[index][0], 0.5) },
                    { offset: 1, color: alpha(colors[index][1], 0.5) },
                ]),
            },
		})),
	};

	// Define the onClick event handler
	const onChartClick = (params) => {
		if (params.componentType === "series") {
			console.log("Series clicked:", params);
			// Handle series click
		} else {
			console.log("Chart area clicked:", params);
			// Handle chart area click
		}
		// You can add more logic here, such as navigating to a different page or updating state
	};

	// Define the event handlers
	const onEvents = {
		click: onChartClick,
	};

	return <ReactECharts option={options} style={{ height: "100%", width: "100%" }} onEvents={onEvents} />;
};

export default StackedGradientLineChart;
